import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [darkMode, setDarkMode] = useState(true);

  const toggleDarkMode = () => setDarkMode(!darkMode);

  // Game Boy Color Palette
  const gbGreen = '#0f380f';
  const gbGreenLight = '#306230';
  const gbYellow = '#8bac0f';
  const gbLightGreen = '#9bbc0f';

  const bgColor = darkMode ? gbGreen : '#e8e8c8';
  const cardBg = darkMode ? gbGreenLight : '#f0f0d8';
  const textColor = darkMode ? gbLightGreen : '#0f380f';
  const accentColor = darkMode ? gbYellow : '#306230';
  const borderColor = darkMode ? gbYellow : '#8bac0f';
  const ctaColor = '#ff0000';

  return (
    <div
      style={{
        backgroundColor: bgColor,
        color: textColor,
        minHeight: '100vh',
        fontFamily: "'Press Start 2P', monospace",
        fontSize: '14px',
        lineHeight: '1.8',
        borderLeft: `8px solid ${borderColor}`,
        borderRight: `8px solid ${borderColor}`,
        boxShadow: darkMode
          ? 'inset 8px 0 20px rgba(0,0,0,0.5), inset -8px 0 20px rgba(0,0,0,0.5)'
          : 'inset 8px 0 20px rgba(0,0,0,0.2), inset -8px 0 20px rgba(0,0,0,0.2)',
      }}
    >
      <div className="container-fluid p-0" style={{ width: '100%' }}>
        {/* Header */}
        <div
          className="d-flex justify-content-between align-items-center px-4 py-3"
          style={{
            backgroundColor: darkMode ? '#1a1a1a' : '#4a4a4a',
            borderBottom: `4px solid ${borderColor}`,
          }}
        >
          {/* Left: Beta Live Indicator */}
          <div
            className="d-flex align-items-center gap-2"
            style={{ color: ctaColor, fontSize: '12px' }}
          >
            <span
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: ctaColor,
                borderRadius: '50%',
                animation: 'blink 1.5s infinite',
              }}
            ></span>
            BETA LIVE
          </div>

          {/* Center: Logo + Text */}
          <div
            className="d-flex align-items-center justify-content-center gap-2"
            style={{ textAlign: 'center' }}
          >
            <img
              src="/images/logo1.jpeg" // ← replace with your actual logo URL
              alt="Logo"
              style={{
                height: '34px',
                width: '34px',
                objectFit: 'contain',
                borderRadius: '50%',
              }}
            />
            <span
              style={{
                fontFamily: "'Press Start 2P', monospace",
                fontSize: '12px',
                color: textColor,
              }}
            >
              Murim Trader
            </span>
          </div>

          {/* Right: Dark Mode Toggle */}
          <button
            onClick={toggleDarkMode}
            className="btn btn-sm"
            style={{
              backgroundColor: accentColor,
              color: bgColor,
              border: `2px solid ${textColor}`,
              fontSize: '10px',
              fontFamily: "'Press Start 2P', monospace",
            }}
          >
            {darkMode ? 'COLOR' : 'CLASSIC'}
          </button>
        </div>


        {/* Hero Section - Above the Fold */}
        <section
          className="text-center py-5 px-3"
          style={{
            backgroundColor: cardBg,
            borderBottom: `4px solid ${borderColor}`,
          }}
        >
          <div className="container my-4">
            {/* Urgency Banner */}
            <div className="mb-4">
              <div
                style={{
                  backgroundColor: ctaColor,
                  color: '#fff',
                  padding: '12px 24px',
                  fontSize: '11px',
                  display: 'inline-block',
                  animation: 'pulse 1.5s infinite',
                  border: '3px solid #000',
                  boxShadow: '4px 4px 0 #000',
                }}
              >
                ⚠ ONLY 50 FOUNDER SLOTS AVAILABLE ⚠
              </div>
            </div>

            {/* Main Headline - Benefit-Driven */}
            <h1
              className="mb-3"
              style={{
                fontSize: '18px',
                lineHeight: '1.5',
                textTransform: 'uppercase',
                fontWeight: '700',
              }}
            >
              Turn Your Trading Journal Into A Game
            </h1>

            {/* Sub-headline - Problem + Solution */}
            <p
              className="mb-4"
              style={{
                fontSize: '13px',
                lineHeight: '1.6',
                maxWidth: '800px',
                margin: '0 auto 30px',
              }}
            >
              Stop drowning in boring spreadsheets. Track trades visually, level up your skills, and actually enjoy journaling.
            </p>

            {/* Primary CTA - Above Video */}
            <div className="mb-4">
              <a
                href="https://tally.so/r/3yLRMW"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-lg"
                style={{
                  backgroundColor: ctaColor,
                  color: '#fff',
                  border: '4px solid #000',
                  padding: '16px 32px',
                  fontSize: '13px',
                  fontFamily: "'Press Start 2P', monospace",
                  textTransform: 'uppercase',
                  boxShadow: '6px 6px 0 #000',
                  animation: 'float 3s ease-in-out infinite',
                  display: 'inline-block',
                  textDecoration: 'none',
                  marginBottom: '10px',
                }}
              >
                Join Beta Now →
              </a>

            </div>

            {/* Hero Content Block */}
            <div
              className="d-flex align-items-center"
              style={{
                backgroundColor: bgColor,
                border: `3px solid ${borderColor}`,
                borderRadius: '8px',
                overflow: 'hidden',
                minHeight: '350px',
                marginTop: '30px',
              }}
            >
              {/* Left: Benefits */}
              <div
                style={{
                  flex: 1,
                  padding: '40px',
                  fontSize: '12px',
                  lineHeight: '1.8',
                  color: textColor,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  animation: 'slideIn 1s ease-out forwards',
                  transform: 'translateX(-100%)',
                  textAlign: 'left',
                }}
              >
                <p className="mb-3" style={{ marginLeft: '0', paddingLeft: '0' }}>
                  ► Visualize every trade with game-like progress tracking
                </p>
                <p className="mb-3" style={{ marginLeft: '0', paddingLeft: '0' }}>
                  ► Watch your win rate climb with instant feedback
                </p>
                <p className="mb-3" style={{ marginLeft: '0', paddingLeft: '0' }}>
                  ► Level up your strategies like a pro trader
                </p>
                <p className="mb-0" style={{ marginLeft: '0', paddingLeft: '0' }}>
                  ► Learn faster and stay consistent—without the spreadsheet pain
                </p>
              </div>

              {/* Right: Video */}
              <div style={{ flex: 1, height: '100%', minHeight: '350px', overflow: 'hidden' }}>
                <video
                  src="/videos/game.mp4"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              </div>
            </div>

            {/* Scroll Indicator */}
            <div
              style={{
                fontSize: '18px',
                marginTop: '30px',
                color: accentColor,
                animation: 'pulse 2s infinite',
                textAlign: 'center',
              }}
            >
              ▼▼▼
            </div>
          </div>
        </section>

        {/* Strategy DNA Section - Core Features */}
        <section
          className="py-5 px-3"
          style={{
            backgroundColor: bgColor,
            borderBottom: `4px solid ${borderColor}`,
          }}
        >
          <div className="container my-5">
            <h2
              className="text-center mb-3"
              style={{
                fontSize: '16px',
                textTransform: 'uppercase',
                fontWeight: '700',
              }}
            >
              The Secret Behind Winning Strategies
            </h2>
            <p
              className="text-center mb-5"
              style={{
                fontSize: '12px',
                color: accentColor,
                maxWidth: '700px',
                margin: '0 auto 40px',
              }}
            >
              Track strategy DNA, evolve your edge, and win consistently like the top 1%
            </p>

            <div className="row g-4">
              {/* Strategy Genetics */}
              <div className="col-md-4">
                <div
                  className="p-4 h-100"
                  style={{
                    backgroundColor: cardBg,
                    border: `3px solid ${borderColor}`,
                    borderRadius: '8px',
                    textAlign: 'center',
                  }}
                >
                  <div style={{ fontSize: '40px', marginBottom: '15px' }}>🧬</div>
                  <h3 style={{ fontSize: '13px', marginBottom: '15px', fontWeight: '700' }}>
                    STRATEGY GENETICS
                  </h3>
                  <p style={{ fontSize: '11px', lineHeight: '1.7', margin: 0 }}>
                    Track the "family tree" of every strategy. Identify winning patterns, kill underperformers, scale winners. Evolve like the pros.
                  </p>
                </div>
              </div>

              {/* Trading DSL */}
              <div className="col-md-4">
                <div
                  className="p-4 h-100"
                  style={{
                    backgroundColor: cardBg,
                    border: `3px solid ${borderColor}`,
                    borderRadius: '8px',
                    textAlign: 'center',
                  }}
                >
                  <div style={{ fontSize: '40px', marginBottom: '15px' }}>⚡</div>
                  <h3 style={{ fontSize: '13px', marginBottom: '15px', fontWeight: '700' }}>
                    TRADING DSL
                  </h3>
                  <p style={{ fontSize: '11px', lineHeight: '1.7', margin: 0 }}>
                    Write strategies in plain English—no coding required. Turn ideas into actionable rules instantly. Implement faster, grow your edge.
                  </p>
                </div>
              </div>

              {/* Advanced Charts */}
              <div className="col-md-4">
                <div
                  className="p-4 h-100"
                  style={{
                    backgroundColor: cardBg,
                    border: `3px solid ${borderColor}`,
                    borderRadius: '8px',
                    textAlign: 'center',
                  }}
                >
                  <div style={{ fontSize: '40px', marginBottom: '15px' }}>📈</div>
                  <h3 style={{ fontSize: '13px', marginBottom: '15px', fontWeight: '700' }}>
                    ADVANCED CHARTS
                  </h3>
                  <p style={{ fontSize: '11px', lineHeight: '1.7', margin: 0 }}>
                    Replay historical markets like a pro. Simulate, pause, analyze trades. Draw insights others miss—turn your journal into a lab.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Trading DSL Deep Dive */}
        <section
          className="py-5 px-3"
          style={{
            backgroundColor: cardBg,
            borderBottom: `4px solid ${borderColor}`,
          }}
        >
          <div className="container">
            <h2
              className="text-center mb-5"
              style={{
                fontSize: '16px',
                textTransform: 'uppercase',
              }}
            >
              The Trading Language Anyone Can Master
            </h2>

            <div className="row g-4 align-items-center">
              {/* LEFT - Video First (More Engaging) */}
              <div className="col-md-6">
                <div
                  className="p-0 h-100 d-flex"
                  style={{
                    backgroundColor: bgColor,
                    border: `3px solid ${borderColor}`,
                    overflow: 'hidden',
                    minHeight: '300px',
                  }}
                >
                  <video
                    src="/videos/dsl.mp4"
                    width="100%"
                    height="100%"
                    style={{
                      objectFit: 'cover',
                      display: 'block',
                    }}
                    autoPlay
                    loop
                    muted
                    playsInline
                  ></video>
                </div>
              </div>

              {/* RIGHT - Explanation */}
              <div className="col-md-6">
                <div
                  className="p-4 h-100"
                  style={{
                    backgroundColor: bgColor,
                    border: `3px solid ${borderColor}`,
                  }}
                >
                  <h3 className="mb-3" style={{ fontSize: '14px' }}>
                    ⚡ Simple, Human-Friendly Trading Rules
                  </h3>
                  <p style={{ fontSize: '11px', lineHeight: '1.8', margin: 0 }}>
                    We're building a lightweight trading language simple enough for anyone to learn. No coding, no syntax headaches—just plain rules you can understand and act on. Connect your data, write strategies like humans think, and teach others without a programming degree. Turn trading into a shared skill that grows across your team.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Advanced Charts with Videos */}
        <section
          className="py-5 px-3"
          style={{
            backgroundColor: bgColor,
            borderBottom: `4px solid ${borderColor}`,
          }}
        >
          <div className="container">
            <h2
              className="text-center mb-5"
              style={{
                fontSize: '16px',
                textTransform: 'uppercase',
              }}
            >
              Professional Trading Charts With Time Travel
            </h2>

            <div className="row g-4 mb-4">
              {/* Charts Video */}
              <div className="col-md-6">
                <div
                  className="p-0 h-100"
                  style={{
                    backgroundColor: cardBg,
                    border: `3px solid ${borderColor}`,
                    overflow: 'hidden',
                    minHeight: '250px',
                  }}
                >
                  <video
                    src="/videos/chart.mp4"
                    width="100%"
                    height="100%"
                    style={{ objectFit: 'cover', display: 'block' }}
                    autoPlay
                    loop
                    muted
                    playsInline
                  ></video>
                </div>
              </div>

              {/* Replay Video */}
              <div className="col-md-6">
                <div
                  className="p-0 h-100"
                  style={{
                    backgroundColor: cardBg,
                    border: `3px solid ${borderColor}`,
                    overflow: 'hidden',
                    minHeight: '250px',
                  }}
                >
                  <video
                    src="/videos/replay.mp4"
                    width="100%"
                    height="100%"
                    style={{ objectFit: 'cover', display: 'block' }}
                    autoPlay
                    loop
                    muted
                    playsInline
                  ></video>
                </div>
              </div>
            </div>

            {/* Features Grid */}
            <div
              className="p-4"
              style={{
                backgroundColor: cardBg,
                border: `3px solid ${borderColor}`,
              }}
            >
              <h3 className="text-center mb-4" style={{ fontSize: '14px' }}>
                Chart & Replay Features
              </h3>
              <div className="row g-4">
                {/* Charts Features */}
                <div className="col-md-6">
                  <div
                    className="p-3 h-100"
                    style={{
                      backgroundColor: bgColor,
                      border: `2px solid ${borderColor}`,
                      fontSize: '11px',
                      lineHeight: '1.8',
                    }}
                  >
                    <h4 style={{ fontSize: '13px', marginBottom: '12px' }}>
                      📊 Professional Trading Charts
                    </h4>
                    <p style={{ margin: '0 0 10px 0' }}>
                      Trade like the pros with tools designed for winners:
                    </p>
                    <p style={{ margin: 0 }}>
                      • Draw support/resistance with precision<br />
                      • Add Fibonacci retracements instantly<br />
                      • Use multiple technical indicators<br />
                      • Analyze multiple timeframes<br />
                      • Custom drawing tools for your strategy
                    </p>
                    <p style={{ fontSize: '10px', marginTop: '12px', color: accentColor }}>
                      🚀 More features coming to give you an unbeatable edge
                    </p>
                  </div>
                </div>

                {/* Replay Features */}
                <div className="col-md-6">
                  <div
                    className="p-3 h-100"
                    style={{
                      backgroundColor: bgColor,
                      border: `2px solid ${borderColor}`,
                      fontSize: '11px',
                      lineHeight: '1.8',
                    }}
                  >
                    <h4 style={{ fontSize: '13px', marginBottom: '12px' }}>
                      ⏰ Market Replay System
                    </h4>
                    <p style={{ margin: '0 0 10px 0' }}>
                      Master markets by learning from the past:
                    </p>
                    <p style={{ margin: 0 }}>
                      • Replay any market period like a pro<br />
                      • Pause, rewind, analyze every setup<br />
                      • Test strategies before risking money<br />
                      • Practice with real or simulated data<br />
                      • Learn from mistakes, repeat wins
                    </p>
                    <p style={{ fontSize: '10px', marginTop: '12px', color: accentColor }}>
                      🔥 More replay modes coming to make learning unstoppable
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Social Proof - Authority Section */}
        <section
          className="py-5 px-3"
          style={{
            backgroundColor: cardBg,
            borderBottom: `4px solid ${borderColor}`,
          }}
        >
          <div className="container">
            <h2
              className="text-center mb-3"
              style={{
                fontSize: '16px',
                textTransform: 'uppercase',
              }}
            >
              Brought to You by the "Three Eyed Scholar"
            </h2>
            <p
              className="text-center mb-5"
              style={{
                fontSize: '11px',
                color: accentColor,
              }}
            >
              Insights trusted by serious traders
            </p>

            <div className="row g-4">
              <div className="col-md-3">
                <div
                  className="p-3 h-100"
                  style={{
                    backgroundColor: bgColor,
                    border: `3px solid ${borderColor}`,
                    textAlign: 'center',
                  }}
                >
                  <a href="https://threeeyedscholar.substack.com/p/the-way-of-the-algorithm" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <img
                      src="/images/alg.jpeg"
                      alt="The way of the algorithm"
                      style={{ width: '100%', height: '120px', objectFit: 'cover', marginBottom: '10px', border: `2px solid ${borderColor}` }}
                    />
                    <div style={{ fontSize: '10px', color: accentColor }}>The way of the algorithm</div>
                  </a>
                </div>
              </div>

              <div className="col-md-3">
                <div
                  className="p-3 h-100"
                  style={{
                    backgroundColor: bgColor,
                    border: `3px solid ${borderColor}`,
                    textAlign: 'center',
                  }}
                >
                  <a href="https://threeeyedscholar.substack.com/p/beyond-the-surface-crafting-your" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <img
                      src="/images/custom.png"
                      alt="Beyond the surface"
                      style={{ width: '100%', height: '120px', objectFit: 'cover', marginBottom: '10px', border: `2px solid ${borderColor}` }}
                    />
                    <div style={{ fontSize: '10px', color: accentColor }}>Beyond the surface</div>
                  </a>
                </div>
              </div>

              <div className="col-md-3">
                <div
                  className="p-3 h-100"
                  style={{
                    backgroundColor: bgColor,
                    border: `3px solid ${borderColor}`,
                    textAlign: 'center',
                  }}
                >
                  <a href="https://threeeyedscholar.substack.com/p/trading-in-time-how-market-sessions" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <img
                      src="/images/sesh.jpeg"
                      alt="Trading in time"
                      style={{ width: '100%', height: '120px', objectFit: 'cover', marginBottom: '10px', border: `2px solid ${borderColor}` }}
                    />
                    <div style={{ fontSize: '10px', color: accentColor }}>Trading in time how market sessions</div>
                  </a>
                </div>
              </div>

              <div className="col-md-3">
                <div
                  className="p-3 h-100"
                  style={{
                    backgroundColor: bgColor,
                    border: `3px solid ${borderColor}`,
                    textAlign: 'center',
                  }}
                >
                  <a href="https://threeeyedscholar.substack.com/p/range-wars-trading-with-the-blade" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <img
                      src="/images/range.png"
                      alt="Range wars"
                      style={{ width: '100%', height: '120px', objectFit: 'cover', marginBottom: '10px', border: `2px solid ${borderColor}` }}
                    />
                    <div style={{ fontSize: '10px', color: accentColor }}>Range wars trading with the blade</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA Section - The Offer */}
        <section
          className="text-center py-5 px-3"
          style={{
            backgroundColor: bgColor,
            borderBottom: `4px solid ${borderColor}`,
          }}
        >
          <div className="container">
            {/* Urgency Reinforcement */}
            <div className="mb-4">
              <div
                style={{
                  backgroundColor: ctaColor,
                  color: '#fff',
                  padding: '12px 24px',
                  fontSize: '11px',
                  display: 'inline-block',
                  animation: 'pulse 1.5s infinite',
                  border: '3px solid #000',
                  boxShadow: '4px 4px 0 #000',
                }}
              >
                ⚠ LIMITED FOUNDER SLOTS - JOIN NOW ⚠
              </div>
            </div>

            <h2
              className="mb-4"
              style={{
                fontSize: '18px',
                textTransform: 'uppercase',
                lineHeight: '1.4',
              }}
            >
              Get The Complete Trading Operating System
            </h2>

            {/* Value Stack */}
            <div
              className="mx-auto my-4 p-4"
              style={{
                backgroundColor: cardBg,
                border: `3px solid ${borderColor}`,
                maxWidth: '650px',
                fontSize: '11px',
                lineHeight: '1.9',
                textAlign: 'left',
              }}
            >
              <p className="mb-3" style={{ fontSize: '12px', fontWeight: '700', textAlign: 'center' }}>
                Everything You Need to Trade Like a Pro:
              </p>
              <p className="mb-2">
                ✓ Strategy Genetics - Track and evolve winning strategies<br />
                ✓ Trading DSL - Write strategies in plain English<br />
                ✓ Advanced Charts - Professional-grade analysis tools<br />
                ✓ Market Replay - Learn from historical data<br />
                ✓ Analytics Dashboard - Track every metric that matters
              </p>
              <div
                style={{
                  backgroundColor: bgColor,
                  padding: '15px',
                  margin: '15px 0',
                  border: `2px solid ${borderColor}`,
                }}
              >
                <p className="mb-2" style={{ fontSize: '12px', color: accentColor, fontWeight: '700' }}>
                  🎮 BONUS: Gamified Trading Journal
                </p>
                <p style={{ fontSize: '11px', margin: 0 }}>
                  Turn your existing Google Sheets or Excel into an interactive, fun experience. Level up, earn rewards, and actually enjoy tracking trades. Learn faster, spot patterns easier, and build the habits that separate winners from losers.
                </p>
              </div>
              <p style={{ fontSize: '11px', textAlign: 'center', color: accentColor, marginTop: '15px' }}>
                🏆 Million-dollar mindset + Founder-exclusive perks included
              </p>
            </div>

            {/* Primary CTA */}
            <a
              href="https://tally.so/r/3yLRMW"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-lg mb-3"
              style={{
                backgroundColor: ctaColor,
                color: '#fff',
                border: '4px solid #000',
                padding: '18px 40px',
                fontSize: '14px',
                fontFamily: "'Press Start 2P', monospace",
                textTransform: 'uppercase',
                boxShadow: '6px 6px 0 #000',
                animation: 'float 3s ease-in-out infinite',
                display: 'inline-block',
                textDecoration: 'none',
              }}
            >
              Become a Founder →
            </a>


          </div>
        </section>

        {/* Footer */}
        <footer
          className="text-center py-4 px-3"
          style={{
            backgroundColor: darkMode ? '#000' : '#2a2a2a',
            color: accentColor,
            fontSize: '10px',
          }}
        >
          <div className="container">
            <p className="mb-2">© 2025 Murim Trader</p>
            <p className="mb-3">Finding knowledge in the darkest part</p>

            {/* Social Links */}
            <div className="d-flex justify-content-center gap-3">
              {/* Twitter */}
              <a
                href="https://x.com/highvillian" // ← replace this
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: accentColor,
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <img
                  src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/x.svg"
                  alt="Twitter"
                  style={{ width: '14px', height: '14px', filter: 'invert(1)' }}
                />
                <span>Twitter</span>
              </a>

              {/* Substack */}
              <a
                href="https://threeeyedscholar.substack.com/" // ← replace this if needed
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: accentColor,
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <img
                  src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/substack.svg"
                  alt="Substack"
                  style={{ width: '14px', height: '14px', filter: 'invert(1)' }}
                />
                <span>Substack</span>
              </a>
            </div>
          </div>
        </footer>

      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');
        
        @keyframes blink {
          0%, 49% { opacity: 1; }
          50%, 100% { opacity: 0; }
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.8; }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        
        @keyframes slideIn {
          0% { transform: translateX(-100%); opacity: 0; }
          100% { transform: translateX(0); opacity: 1; }
        }
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          margin: 0;
          padding: 0;
          background-color: #1a1a1a;
        }
        
        .gap-2 {
          gap: 0.5rem;
        }
        
        .gap-3 {
          gap: 1rem;
        }

        .gap-4 {
          gap: 1.5rem;
        }
      `}</style>
    </div>
  );
}

export default App;